export function Logo({ size = 'md' }) {
  const sizes = {
    sm: 'w-9 h-9',
    md: 'w-12 h-12',
    lg: 'w-14 h-14',
  };
  return (
    <img
      src="/logo192.png"
      alt="index24hrs.com"
      className={`${sizes[size] || sizes.md} object-contain`}
    />
  );
}

export function LogoText({ className = '', size = 'md' }) {
  const sizeStyles = {
    sm: { fontSize: '0.95rem', fontWeight: 800 },
    md: { fontSize: '1.5rem', fontWeight: 900 },
    lg: { fontSize: '2rem', fontWeight: 900 },
  };
  const s = sizeStyles[size] || sizeStyles.md;
  return (
    <span className={className} style={{ fontWeight: s.fontWeight, fontStyle: 'italic', letterSpacing: '-0.02em', lineHeight: 1 }}>
      <span style={{ color: '#1a56a8', fontSize: s.fontSize }}>Index</span>
      <span style={{ color: '#f07d1a', fontSize: s.fontSize }}>24</span>
      <span style={{ color: '#1a56a8', fontSize: s.fontSize }}>hrs</span>
      <span style={{ color: '#1a56a8', fontSize: `calc(${s.fontSize} * 0.7)` }}>.com</span>
    </span>
  );
}
